import React from 'react'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import CommonTable from '../../components/CommonTable'

const ApplicationDetails = () => {
  const { applicationDetails, isLoading } = useSelector((state) => state.application)

  if (isLoading) {
    return <Spin size="large" />
  }

  if (!applicationDetails) {
    return <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>No data available</div>
  }

  const dataSource = [
    {
      key: '1',
      field: 'Application Name',
      value: applicationDetails.applicationName || 'N/A',
    },
    {
      key: '2',
      field: 'Application APM ID',
      value: applicationDetails.applicationAPMID || 'N/A',
    },
    {
      key: '3',
      field: 'UMID',
      value: applicationDetails.uami || applicationDetails.umid || applicationDetails.UMID || 'N/A',
    },
    {
      key: '4',
      field: 'Application Classification',
      value: applicationDetails.appCategory || applicationDetails.applicationClassification || applicationDetails.classification || 'N/A',
    },
    {
      key: '5',
      field: 'Technology Stack',
      value: applicationDetails.technologyStack || applicationDetails.techStack || 'N/A',
    },
    {
      key: '6',
      field: 'Functional Owner',
      value: applicationDetails.functionalOwner || 'N/A',
    },
    {
      key: '7',
      field: 'TL (Team Lead)',
      value: applicationDetails.technicalLead || applicationDetails.teamLead || applicationDetails.TL || 'N/A',
    },
    {
      key: '8',
      field: 'Portfolio Sponsor',
      value: applicationDetails.portFolioSponsor || applicationDetails.portfolioSponsor || 'N/A',
    },
    {
      key: '9',
      field: 'Project Manager',
      value: applicationDetails.projectManager || 'N/A',
    },
    {
      key: '10',
      field: 'Business Analyst',
      value: applicationDetails.businessAnalyst || 'N/A',
    },
    {
      key: '11',
      field: 'Quality Analyst',
      value: applicationDetails.qualityAnalyst || 'N/A',
    },
    {
      key: '12',
      field: 'Developer',
      value: applicationDetails.developer || 'N/A',
    },
    {
      key: '13',
      field: 'Secondary Developer',
      value: applicationDetails.secondaryDeveloper || 'N/A',
    },
    {
      key: '14',
      field: 'Application URL',
      value: applicationDetails.applicationURL ? (
        <a href={applicationDetails.applicationURL} target="_blank" rel="noopener noreferrer">
          {applicationDetails.applicationURL}
        </a>
      ) : (
        'N/A'
      ),
    },
  ]

  const columns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      width: '30%',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ]

  return (
    <CommonTable
      columns={columns}
      dataSource={dataSource}
      rowKey="key"
      pagination={false}
    />
  )
}

export default ApplicationDetails
